import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,SyncSeek_action,SyncMakeGetUrl, SyncPullSerialized_action, CTimeStamp} from "datasync-common-library";
import { GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously, SaveDataTierToDatasyncSynchronously } from "datasync-core";
import { globals, getEventAsDate} from "../../src/Components/Globals/Globals";
import {produce} from "immer"

const initialState = {
  eventsItems: [],
  eventCount: 0,
  loadEvents_result:{status: 'idle', error: null},
  deleteEvent_result:{status: 'idle', error: null},
  reassign_result : {status : "idle", error : null, event_name: null, user_action:null, user_guid_owner:null},
}

// Create an async thunk for loading events
export const loadEvents = createAsyncThunk(
  'events/loadEvents',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.thononadvent_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        //seek_filter_clause: ` data_blob like '%"validation":"Oui"%' `, // Display only validated events
        seek_filter_clause: ` true `, // Display only validated events
        table_guid: globals.datasync.adv_events_table_guid,
        debugging: true
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting events
export const deleteEvent = createAsyncThunk(
  'events/deleteEvent',
  async (deletedEventObject) => {
    try {
      console.clear()
      console.log("deletedEventObject->", deletedEventObject)
      //Delete event from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedEventObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteEvent->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedEventObject.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for reassignEvent events
export const reassignEvent = createAsyncThunk(
  'events/reassignEvent',
  async (reassignPackObject) => {
    if (globals.parameters.debugging){
      console.log("reassignPackObject->", reassignPackObject)
    }

    let reassignEventOriginalObject = reassignPackObject.event_data_guid;
    let next_event_validation_value = (reassignPackObject.user_action === "valider") ? "Oui" : "Non";
    try {
      if (globals.parameters.debugging){
        console.clear()
        console.log("reassignEventOriginalObject->", reassignEventOriginalObject)
      }

      //Change event validation field from Remote Datasync Database
      let reassignEventObject = JSON.parse(JSON.stringify(reassignEventOriginalObject))
      reassignEventObject.data_blob.data_tier["validation"] = next_event_validation_value;

      
      //Save data to Remote Datasync Database
      const response = await SaveDataTierToDatasyncSynchronously (
        globals.datasync_service.url,
        reassignEventObject.data_guid, 
        reassignEventObject.data_blob, //p_o_form,
        globals.datasync.thononadvent_company_guid,//p_s_company_guid,
        globals.datasync.adv_events_table_guid,//p_s_table_guid,
        reassignEventObject.createstamp, //p_dt_createstamp,
        CTimeStamp(),//p_dt_updatestamp,
        null,//p_dt_deletestamp,
        )
      
      if (globals.parameters.debugging)
        console.log("reassignEvent->response = ",response)

      if (!response)
        throw("reassignEvent: response is null")

      return {reassignedEventObject:response, user_action:reassignPackObject.user_action};
    } catch (error) {
      console.error("reassignEvent: error ->", error)
      //return reassignEventObject.rejectWithValue(error.message);
      return (error);
    }
  }
);

const eventSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    addEvent(state, action) {
      // New event added 
      try {
        if (globals.parameters.debugging){
          console.log("addEvent: ", state.eventsItems)
          console.log("addEvent: ", state.eventCount)
          console.log("addEvent::action ->", action)  
        }
  
        state.eventCount++;
        state.eventsItems.push(action.payload);
      } catch (error) {
        console.error("Event added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel event en mémoire interne")
      }
    },

    updateEvent(state, action) {
      return produce(state, draft => {
        //Find former event object to update
        const updatedEventObject = draft.eventsItems.find((event) => event.data_guid === action.payload.data_guid)
        console.log("updateEvent: updatedEventObject->", updatedEventObject)
        if (updatedEventObject) {
          //update event in the array
          updatedEventObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateEvent: Event not found in the array");
        }
      })
    },

    revertAllEvents(state){
      console.log("eventSlice revertAll");
      //state = initialState;
      //console.log("state.eventCount ->",state.eventCount)
      state.eventCount = 0;
      state.eventsItems = [];
      state.loadEvents_result = {status: 'idle', error: null};
      state.deleteEvent_result = {status: 'idle', error: null};
      state.reassign_result = {status : "idle", error : null, event_name: null, user_action:null, user_guid_owner:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadEvents */
      .addCase(loadEvents.pending, (state, action) => {
        state.loadEvents_result = {status : "loading",error : null};
      })
      .addCase(loadEvents.fulfilled, (state, action) => {
        try {
          state.loadEvents_result = {status : "succeeded",error : null};
          
          console.clear()
          
          //state.eventsItems = action.payload.sort((a,b) => (parseInt(a.data_blob.data_tier.month) > parseInt(b.data_blob.data_tier.month))?1:-1);//Let us sor events by timestamp descending
          state.eventsItems = action.payload.sort((a,b) => (getEventAsDate(a.data_blob.data_tier) > getEventAsDate(b.data_blob.data_tier))?1:-1);//Let us sor events by timestamp descending
          state.eventCount= action.payload.length;          
        } catch (error) {
          console.error(error)
          state.loadEvents_result = {status : "succeeded",error : "No events found !!!"};
          state.eventsItems = [];
          state.eventCount= 0;          
        }
      })
      .addCase(loadEvents.rejected, (state, action) => {
        state.loadEvents_result = {status : "failed",error : action.payload};
      })
      
      /* deleteEvent */
      .addCase(deleteEvent.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteEvent.pending")
        console.log("deleteEvent.pending -> action", action)
        state.deleteEvent_result = {status : "deleting",error : null};
      })
      .addCase(deleteEvent.fulfilled, (state,action) => {
        //Event sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteEvent.fulfilled")
          console.log("deleteEvent.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete event from local state
          draft.eventsItems = draft.eventsItems.filter((event, j) => event.data_guid !== action.payload.data_guid)
          draft.eventCount--;

          draft.deleteEvent_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteEvent.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteEvent.rejected")
          console.log("deleteEvent.rejected -> action", action)
        state.deleteEvent_result = {status : "failed",error : action.payload};
      })

      /* reassignEvent */
      .addCase(reassignEvent.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("reassignEvent.pending")
        console.log("reassignEvent.pending -> action", action)

        state.reassign_result = {status : "reassigning", error : null, event_name: null, action:null}
      })
      .addCase(reassignEvent.fulfilled, (state,action) => {
        //Event sucessfully reassign from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("reassignEvent.fulfilled")
          console.log("reassignEvent.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Find former event object to update
          const reassignedEventObject = draft.eventsItems.find((event) => event.data_guid === action.payload.reassignedEventObject.data_guid)
          const user_action = action.payload.user_action;
          const event_name = action.payload.reassignedEventObject.data_blob.data_tier.Event_name;
          const user_guid_owner = action.payload.reassignedEventObject.data_blob.data_tier.user_guid;

          if (globals.parameters.redux_debugging){
            console.log("reassignEvent: reassignedEventObject->", reassignedEventObject)
            console.log("reassignEvent: user_action->", user_action)
          }

          if (reassignedEventObject) {
            //update the event in the array
            reassignedEventObject.data_blob.data_tier = action.payload.reassignedEventObject.data_blob.data_tier;
            reassignedEventObject.updatestamp = action.payload.reassignedEventObject.updatestamp;

            Object.assign(draft.reassign_result, {status: "reassigned",event_name:event_name, user_guid_owner:user_guid_owner, user_action:user_action, error:null})
            
          } else {
            console.error("reassignEvent: Event not found in the array");
          }
        })
      })
      .addCase(reassignEvent.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("reassignEvent.rejected")
        console.log("reassignEvent.rejected -> action", action)

        Object.assign(state.reassign_result, {status: "failed",error:null})
      })
  },
});

export const { addEvent, updateEvent, revertAllEvents, reassign_result } = eventSlice.actions;
export default eventSlice.reducer;
